<template>
  <div class="my_select_time">
    <el-date-picker
      prefix-icon="no_icon"
      v-model="start"
      :type="type"
      :placeholder="'开始时间'"
      size="small"
      :format="timeFormat"
      :value-format="timeFormat"
      class="time1"
      :picker-options="startOptions"
      :default-value="defaultValueStart"
      :default-time="defaultTimeStart"
      :clearable="clearable"
      :disabled="disabled"
    ></el-date-picker>
    <div class="time_to_text">至</div>
    <el-date-picker
      prefix-icon="no_icon"
      v-model="end"
      :type="type"
      :placeholder="'结束时间'"
      size="small"
      :format="timeFormat"
      :value-format="timeFormat"
      class="time2"
      :picker-options="endOptions"
      :default-value="defaultValueEnd"
      :default-time="defaultTimeEnd"
      :clearable="clearable"
      :disabled="disabled"
    ></el-date-picker>
  </div>
</template>

<script>
/**入参
 * props:
 *  startTime
 *  endTime
 *  type 显示类型
 *  format 时间格式 datetime默认为"yyyy-MM-dd HH:mm:ss" date默认为"yyyy-MM-dd"
 *  pickerOptionsStart 开始时间的picker-options; pickerOptionsEnd 结束时间的picker-options
 *  defaultValueStart  开始时间的default-value;  defaultValueEnd 结束时间的default-value
 *  defaultTimeStart   开始时间的default-time;   defaultTimeEnd 结束时间的default-time
 *  clearable  是否开启清除按钮
 *
 * 事件
 * event：change(start,end)
 *
 */
export default {
  name: "MyTimePicker",
  components: {},
  props: {
    startTime: {
      default: "",
    },
    endTime: {
      default: "",
    },
    type: {
      default: "date",
    },
    format: {
      default: "",
    },
    pickerOptionsStart: {
      default: () => {
        return {};
      },
    },
    pickerOptionsEnd: {
      default: () => {
        return {};
      },
    },
    defaultValueStart: {
      default: "",
    },
    defaultValueEnd: {
      default: "",
    },
    defaultTimeStart: {
      default: "00:00:00",
    },
    defaultTimeEnd: {
      default: "23:59:59",
    },
    clearable: {
      default: true,
    },
    disabled: {
      default: false,
    },
    defalutLimit: {
      //开启限制 初始值不大于结尾值
      default: false,
    },
  },
  data() {
    return {
      form: {
        startTime: "",
        endTime: "",
      },
    };
  },
  computed: {
    start: {
      get: function () {
        return this.startTime;
      },
      set: function (val) {
        this.$emit("change", { startTime: val, endTime: this.end });
      },
    },
    end: {
      get: function () {
        return this.endTime;
      },
      set: function (val) {
        this.$emit("change", { startTime: this.start, endTime: val });
      },
    },
    timeFormat() {
      if (this.format != "") {
        return this.format;
      } else if (this.type == "datetime") {
        return "yyyy-MM-dd HH:mm:ss";
      } else if (this.type == "date") {
        return "yyyy-MM-dd";
      } else {
        return "yyyy-MM-dd";
      }
    },
    startOptions() {
      if (this.defalutLimit) {
        return {
          disabledDate: (time) => {
            if (this.end) {
              return time.getTime() > new Date(this.end).getTime() - 28800000;
            } else {
            }
          },
        };
      } else {
        return this.pickerOptionsStart;
      }
    },
    endOptions() {
      if (this.defalutLimit) {
        return {
          disabledDate: (time) => {
            if (this.start) {
              return time.getTime() < new Date(this.start).getTime() - 28800000;
            } else {
            }
          },
        };
      } else {
        return this.pickerOptionsEnd;
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    clearTimeSendTime() {
      this.$emit("change", { startTime: "", endTime: "" });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 4px;
}

/deep/ .el-input--suffix .el-input__inner {
  padding-right: 0;
}

.my_select_time {
  display: flex;
  align-items: center;

  .time_to_text {
    display: inline-block;
    font-size: 14px;
    padding: 0px !important;
    height: 30px;
    line-height: 28px;
    color: #333;
    margin: 0 4px;
    text-align: center;
    width: 14px;
    font-size: 12px;
  }

  .time1,
  .time2 {
    flex: 1;
    /deep/ .el-input__inner {
      padding-right: 15px;
      font-family: none;
    }
    /deep/ .el-input__icon {
      line-height: 34px;
    }
  }
}
</style>
